<template>
  <div class="popUpWrap">
    <section class="popup light">
      <div class="topArea">
        <h4>{{ t('organization-member-information') }}</h4>
        <div class="exit" @click.stop="dialogStore.close"></div>
      </div>
      <div class="scrollY">
        <LazyOrganizationMemberInvitedForm
          :email="organizationMember.email"
          :profile-img="organizationMember.profileImageUrl"
          :full-name="organizationMember.fullName"
          :user-uuid="organizationMember.userUuid"
          :role="organizationMember.organizationRole"
          :menu="organizationMember.menuAccessRoles"
          :menu-error="menuError"
          :is-modify="true"
          @update:role="(v) => (organizationMember.organizationRole = v)"
          @update:menu="(v) => (organizationMember.menuAccessRoles = v)"
        />
        <div class="btnArea">
          <button type="button" class="btn" @click.stop="onClickUpdateMemberRole">
            {{ t('common-save') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useToastStore } from "~/store/toast/toastStore";
import { useOrganizationService } from "~/composables/service/useOrganizationService";
import { OrganizationInviteMemberModel } from "~~/package/mapper/organization/model/OrganizationInviteMemberModel";
import { UserV2Type } from "~~/package/mapper/user/model/UserType";
import { ToastType } from "~/components/Common/Toast/model/ToastType";
import { OrganizationMemberModel } from "~~/package/mapper/organization/model/OrganizationMemberModel";

const { t } = useI18n();
const dialogStore = useDialogStore();
const toastStore = useToastStore();
const organizationService = useOrganizationService();

const menuError = ref(false);

const organizationMember = ref(new OrganizationMemberModel());

const validateMember = () => {
  const accessRoles = organizationMember.value.menuAccessRoles;

  if (!accessRoles || accessRoles.length === 0) {
    menuError.value = true;
    return false;
  }

  return true;
}

const onClickUpdateMemberRole = () => {
  if(!validateMember()) return;

  organizationService.updateOrganizationMemberRole(
    organizationMember.value.userUuid,
    organizationMember.value.organizationRole,
    organizationMember.value.menuAccessRoles
  ).then((isSuccess: boolean) => {
    if(isSuccess) handlerSuccess();
    else handlerFail();
  }).catch(handlerFail);
}

const handlerSuccess = () => {
  toastStore.openToast({
    toastType: ToastType.SUCCESS,
    contents: t("organization-member-information-success"),
  });
  dialogStore.options.confirm?.event();
  dialogStore.close();
}

const handlerFail = () => {
  toastStore.openToast({
    toastType: ToastType.FAILED,
    contents: t("organization-member-information-fail"),
  });
}

onMounted(() => {
  organizationMember.value = dialogStore.options.props.organizationMember;
})
</script>
